// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","962":"jump"}[chunkId] || chunkId) + "-legacy." + {"158":"0061903d","443":"f1651021","962":"48cd0546"}[chunkId] + ".js";
};